module.exports = __webpack_public_path__ + "img/27.d43e6e7a.png";